module.exports = __webpack_public_path__ + "img/Icons-1.f90e993.svg";